<template>
  <div id="app">
    <notifications position="bottom right" />
    <notifications group="alert" position="top right" />
    <notifications group="quiz" position="bottom left" />
    <van-nav-bar v-if="!zenMode" :title="title">
      <template
        #left
        v-if="
          $route.name == 'classes' ||
            $route.name == 'my-boxes' ||
            $route.name == 'Home' ||
            $route.name == 'registered'
        "
      >
        <img
          id="sprkr-icon"
          src="@/assets/vokabox-icon.png"
          width="40"
          :alt="$t('app-icon.alt')"
          @click="gotoHomepage($event)"
        />
      </template>
      <template #left v-else>
        <i class="fas fa-arrow-left" @click="onClickLeft"></i>
      </template>
      <template #right>
        <div id="account" v-if="loggedIn">
          <router-link class="profile-icon" :to="{ name: 'account' }">
            <img
              class="profile-img"
              v-if="user.image"
              :src="imgsrc(user.image)"
              alt="profile image"
            />
            <i v-else class="far fa-user-circle" />
          </router-link>
        </div>
        <div v-else>
          <van-button
            type="info"
            :to="{ name: 'login' }"
            style="margin-right:10px"
          >
            {{ $t("login") }}
          </van-button>
          <van-button plain type="primary" :to="{ name: 'register' }">
            {{ $t("register") }}
          </van-button>
        </div>
      </template>
    </van-nav-bar>
    <router-view
      :class="{ 'non-zenMode': !zenMode, 'tabbar-free': !showTabNav() }"
    />
    <van-tabbar route v-if="!zenMode && showTabNav()">
      <van-tabbar-item
        replace
        v-for="{ name, icon, to } in items"
        :to="to"
        :key="name"
        :icon="icon"
      >
        {{ name }}
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  name: "App",
  computed: {
    ...mapState("setting", ["zenMode", "title", "lastRoute"]),
    ...mapState("account", ["loggedIn", "user"])
  },
  data() {
    return {
      active: 0,
      items: [
        { name: "home", to: "/", icon: "wap-home-o" },
        { name: "classrooms", to: "/my-classrooms", icon: "home-o" },
        { name: "boxes", to: "/my-boxes", icon: "sign" },
        { name: "tests", to: "/placement-tests", icon: "records" }
      ]
    };
  },
  methods: {
    ...mapActions("account", ["logout"]),
    ...mapActions("vokabel", ["getFavBox"]),
    ...mapActions("setting", ["navigateBack"]),
    ...mapMutations("setting", ["CLOSE_ZEN_MODE"]),
    showTabNav() {
      return this.items.some(item => {
        return this.$route.path == item.to;
      });
    },
    imgsrc(image) {
      return image
        ? `https://f002.backblazeb2.com/file/sprkr-user-uploads/${image}`
        : "";
    },
    gotoHomepage(e) {
      e.stopPropagation();
      window.location = "https://vokabox.com";
    },
    onClickLeft() {
      this.navigateBack();
      this.CLOSE_ZEN_MODE();
    }
  },
  created() {
    if (this.loggedIn) {
      this.getFavBox();
    }
  }
};
</script>

<style lang="scss">
* {
  box-sizing: border-box;
}

#app {
  font-family: "Montserrat", Helvetica, Arial, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}

#nav-tabbar {
  .van-tabbar-item {
    font-weight: bold;
    color: #2c3e50;
  }
  .van-tabbar-item--active {
    color: #42b983;
  }
}

#account i.far {
  color: #2c3e50;
  font-size: 1.75rem;
}

.exit-zen-mode {
  left: 3px;
  font-size: 1.3rem;
  position: absolute;
  top: 0;
  z-index: 10000;
}
.non-zenMode {
  height: calc(100vh - 119px);
  overflow-y: scroll;

  &.tabbar-free {
    height: calc(100vh - 70px);
  }
}

.profile-icon {
  position: relative;
  border: 1px solid rgba(245, 245, 245, 0.1);
  background: rgba(245, 245, 245, 0.5);
  border-radius: 50%;
  height: 30px;
  width: 30px;
  display: flex;
  justify-self: center;
  align-self: center;
  justify-items: center;
  align-content: center;
  align-self: center;
  align-items: center;
  justify-content: center;
  justify-items: center;
  justify-self: center;
  margin: 10px auto;
  text-align: center;
  overflow: hidden;
  .profile-img {
    width: auto;
    height: 100%;
  }
}

.van-nav-bar {
  &.van-hairline--bottom {
    padding: 35px;
    box-shadow: 0 0 25px #e3e3e3;

    .van-nav-bar__title {
      max-width: 100% !important;
      margin: 0 !important;
      color: #323233;
      font-weight: 500;
      font-size: 16px;
      padding-left: 35px;
      &.van-ellipsis {
        font-weight: bold;
      }
    }
  }
}
.van-tabbar {
  font-weight: bold;
}

.btn {
  border: none;
  color: inherit;
  background: none;
  cursor: pointer;
  padding: 10px 20px;
  display: inline-block;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 700;
  outline: none;
  position: relative;
  transition: all 0.3s;
  background: #34495e;
  color: #fff;
  margin: 2.5px;
}

.btn:hover {
  background: #2c3e50;
}

.btn:active {
  background: #2c3e50;
  top: 2px;
}
</style>
